import React, { PureComponent } from 'react'
import styles from './MobilePublishComponent.scss'
import { connect } from 'react-redux'
import { setHeaderMode } from '@/store/actions'
import { MagazinesResource, PublishResource } from '@/resources'
import { RenderPages } from './RenderPages'
import { makeCancelable } from '@/utils/cancelablePromise'
import { debounce } from '@/utils/debounce'
import { MagazineLoader } from '@/components/commons/LoaderComponent'
import {defaultPageSize, pageSizeFromMagazine} from "../../utils/pageSize";
const isMobile = require( 'ismobilejs' )

class MobilePages extends PureComponent {
  startX = 0
  range = 100
  observer = null
  pageRequest = null
  insectorInterval = null
  pagesOffset = null
  _mounted = false

  state = {
    pages: [],
    pageIndex: 1,
    pageSize: defaultPageSize,
    ratio: 1,
    threshold: 0.7,
    loading: true
  }

  componentWillMount () {
    document.documentElement.style.overflow = 'hidden'
    
    
    /** inicio da gambi pra resolver problema de scroll devido a lib */
    const cssBA = document.getElementById( 'css-builderall-lib' )
    const jsBA  = document.getElementById( 'js-builderall-lib' )

    if( cssBA ) cssBA.remove()
    if( jsBA )  jsBA.remove()
    /** fim da gambi pra resolver problema de scroll devido a lib */
  }

  componentDidMount () {
    this._mounted = true
    this.props.setHeaderMode( 'hidden' )
    const {
      params: { magazineId }
    } = this.props.match
    const pageRequest = makeCancelable( MagazinesResource.getPages( magazineId ) )
    pageRequest.promise.then( ( { data: pages } ) => {
      this.configure( () => {
        this.setState( { pages } )
        this.insectorInterval = setTimeout(
          () => this.configureIntersector(),
          1000
        )
      } )
    } )
    this.configureChangesObserver()
    document.addEventListener( 'click', this.onGoPage )

    PublishResource.getById( magazineId )
        .then(({ data:magazine }) => {
          this.setState({pageSize: pageSizeFromMagazine(magazine)})
        })
  }

  componentDidUpdate () {
    const { loading } = this.state
    if ( !loading ) document.documentElement.style.overflow = 'auto'
  }

  /**
   * Create Link for page mobile
   * @param {Object} event
   */
  onGoPage = event => {
    
    const { target } = event

    const link = target.closest( 'a' )

    if( !link ) return
    
    const hasAttributeHref = link.hasAttribute( 'href' )

    if ( !hasAttributeHref ) return false

    const goPage = target.closest( 'a' ).getAttribute( 'href' ).replace( '#page-', '' )
    const pages = document.querySelectorAll( 'div[data-page]' )

    pages[goPage-1].scrollIntoView( { behavior: 'smooth' } )
  }

  configureChangesObserver = () => {
    const config = { childList: true, attibutes: true }
    this.observer = new MutationObserver( mutations => {
      let images = []
      mutations.forEach( el => {
        el.addedNodes.forEach( addedItem => {
          const imgs = addedItem.querySelectorAll( 'img' )
          images = [ ...images, ...imgs ]
        } )
      } )
      this.loadImages( images )
    } )
    this.observer.observe( this.refs.rootEl, config )
  }

  loadImages = images => {
    let loaded = 0
    images.map( image => {
      image.onload = () => {
        if ( ++loaded === images.length ) {
          if ( this._mounted ) {
            this.setState( { loading: false } )
          }
        }
      }
      return image
    } )

    this.setState( { loading: false } )
  }

  componentWillUnmount () {
    this._mounted = false
    if ( this.pageRequest ) {
      this.pageRequest.cancel()
    }
    if ( this.insectorInterval ) {
      window.clearTimeout( this.insectorInterval )
    }
    if ( this.observer ) {
      this.observer.disconnect()
    }
    document.removeEventListener( 'scroll', this.intersectCallback )
  }

  configure = callback => {
    const {pageSize} = this.state

    const ratio = window.innerWidth / pageSize.width
    const threshold = window.innerWidth > window.innerHeight ? 0.2 : 0.7
    this.setState( {
      pageSize: {
        width: window.innerWidth,
        height: pageSize.height * ratio
      },
      pageIndex: 1,
      ratio: ratio,
      threshold
    } )
    if ( callback && typeof callback === 'function' ) {
      callback()
    }
  }

  configureIntersector = () => {
    this.pagesOffset = Array.from(
      document.querySelectorAll( 'div[data-page]' )
    ).map( page => {
      const bounds = page.getBoundingClientRect()
      const index = page.getAttribute( 'data-page' )
      return {
        top: bounds.top,
        index
      }
    } )
    document.addEventListener( 'scroll', debounce( this.intersectCallback, 10 ) )
  }

  intersectCallback = e => {
    const { height } = this.state.pageSize
    const top = this.getScrollTop()
    const middle = height / 2
    this.pagesOffset.forEach( offset => {
      const pagePos = offset.top - top
      const heightOffset = pagePos + height

      if ( pagePos < middle && heightOffset > middle ) {
        if ( this._mounted ) {
          this.setState( {
            pageIndex: offset.index
          } )
        }
      }
    } )
  }

  getScrollTop = () => {
    const supportPageOffset = window.pageXOffset !== undefined
    const isCSS1Compat = ( document.compatMode || '' ) === 'CSS1Compat'
    return supportPageOffset
      ? window.pageYOffset
      : isCSS1Compat
        ? document.documentElement.scrollTop
        : document.body.scrollTop
  }

  render () {
    const { pages, pageIndex, loading } = this.state

    return (
      <section className={styles.container} ref="rootEl">
        {pages.map( ( page, index ) => {
          let pageStyle = {}
          if ( page.properties ) {
            pageStyle = JSON.parse( page.properties )
          }
          pageStyle = {
            ...pageStyle,
            ...this.state.pageSize
          }
          return (
            <div
              className={styles.page}
              key={page.id}
              style={pageStyle}
              data-page={index + 1}
            >
              <RenderPages singlePage={page} scaleFactor={this.state.ratio} start={true} />
            </div>
          )
        } )}

        {!isMobile.apple.device && (
          <div className={styles['page-couter']}>
            page {pageIndex} of {pages.length}
          </div>
        )}
        {loading && <MagazineLoader />}
      </section>
    )
  }
}

class MobilePublishComponent extends PureComponent {
  state = {
    orientation: ''
  }

  /**
   * Get portrait or landscape from mobile
   */
  componentDidMount () {
    const orientation = !window.orientation ? 'portrait' : 'landscape'
    this.setState( { orientation } )
  }

  render () {
    const { orientation } = this.state
    return (
      <React.Fragment>
        {orientation === 'portrait' ? (
          <MobilePages key="portrait" {...this.props} />
        ) : (
          <MobilePages key="landscape" {...this.props} />
        )}
      </React.Fragment>
    )
  }
}

export default connect(
  null,
  { setHeaderMode }
)( MobilePublishComponent )



// WEBPACK FOOTER //
// ./src/components/publish/MobilePublishComponent.js